export const CONSENT_VALUES = ['unknown', 'granted', 'declined'];
/** Whether an event may be sent. The only place that decision is made. */
export function mayCount(consent) {
    return consent === 'granted';
}
/** Whether the question is still owed. Neither answer needs asking again. */
export function shouldAsk(consent) {
    return consent === 'unknown';
}
/** Reads a stored value without trusting it: anything unrecognised is "not asked". */
export function readConsent(stored) {
    return stored === 'granted' || stored === 'declined' ? stored : 'unknown';
}
//# sourceMappingURL=consent.js.map